import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgIllnessCold = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.9592 21.375V16.1542C19.1106 15.0874 19.9137 13.6983 20.2634 12.1681C20.6132 10.6379 20.4934 9.03778 19.9197 7.57673C19.346 6.11568 18.345 4.86158 17.0475 3.9782C15.75 3.09483 14.2163 2.62323 12.6467 2.625C6.6975 2.625 5.41667 7.52333 3.2925 13.025C3.25617 13.1197 3.2434 13.2218 3.2553 13.3226C3.26719 13.4233 3.3034 13.5197 3.3608 13.6033C3.4182 13.6869 3.49507 13.7554 3.58479 13.8027C3.67451 13.85 3.77439 13.8748 3.87583 13.875H5.45917V16.375C5.45917 17.038 5.72256 17.6739 6.1914 18.1428C6.66024 18.6116 7.29613 18.875 7.95917 18.875H9.20917V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.20923 14.1875C9.29211 14.1875 9.37159 14.2204 9.4302 14.279C9.4888 14.3376 9.52173 14.4171 9.52173 14.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.89673 14.5C8.89673 14.4171 8.92965 14.3376 8.98826 14.279C9.04686 14.2204 9.12635 14.1875 9.20923 14.1875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.20923 14.8125C9.12635 14.8125 9.04686 14.7796 8.98826 14.721C8.92965 14.6624 8.89673 14.5829 8.89673 14.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.52173 14.5C9.52173 14.5829 9.4888 14.6624 9.4302 14.721C9.37159 14.7796 9.29211 14.8125 9.20923 14.8125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7092 11.0625C11.7921 11.0625 11.8716 11.0954 11.9302 11.154C11.9888 11.2126 12.0217 11.2921 12.0217 11.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3967 11.375C11.3967 11.2921 11.4297 11.2126 11.4883 11.154C11.5469 11.0954 11.6263 11.0625 11.7092 11.0625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7092 11.6875C11.6263 11.6875 11.5469 11.6546 11.4883 11.596C11.4297 11.5374 11.3967 11.4579 11.3967 11.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0217 11.375C12.0217 11.4579 11.9888 11.5374 11.9302 11.596C11.8716 11.6546 11.7921 11.6875 11.7092 11.6875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5833 14.1875C13.6661 14.1875 13.7456 14.2204 13.8042 14.279C13.8628 14.3376 13.8958 14.4171 13.8958 14.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2717 14.5C13.2717 14.4171 13.3047 14.3376 13.3633 14.279C13.4219 14.2204 13.5013 14.1875 13.5842 14.1875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5834 14.8125C13.5007 14.8123 13.4214 14.7793 13.363 14.7207C13.3045 14.6621 13.2717 14.5827 13.2717 14.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8967 14.5C13.8967 14.5829 13.8638 14.6624 13.8052 14.721C13.7466 14.7796 13.6671 14.8125 13.5842 14.8125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgIllnessCold.displayName = 'SvgIllnessCold';
export default SvgIllnessCold;
